import React, { useEffect, useState, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navbar from "../components/Navbar";
import PdfThumnailView from "../components/PdfThumbnailView";
import DocView from "../components/DocView";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { axiosRequest } from "../axiosConfig";
import { pdfCacheManager } from "../utils/pdfCacheManager";

const ViewPage = (props) => {
  const history = useHistory();
  const [uploadedPdf, setUploadedPdf] = useState("");
  const [uploadFiles, setUploadeFiles] = useState("");
  const [pagesArray, setPagesArray] = useState([]);
  const [pageOriginalNum, setpageOriginalNum] = useState([]);
  const [currentPage, setCurrentPage] = useState("parent");
  const [cookies] = useCookies();
  const [isLocked, setIsLocked] = useState(true);

  // Check the user and verify if the fax is locked.
  useEffect(() => {
    if (!cookies?.firstName) {
      window.location.replace(window.location.origin);
    }
    let faxId = "";
    if (props?.location?.state?.pdfVal) {
      faxId = props?.location?.state?.pdfVal?.Id;
    } else if (props?.location?.state?.parent) {
      faxId = props?.location?.state?.parent?.Id;
    }

    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}faxlocked/${faxId}`)
      .then((res) => {
        if (res.data.email && cookies.email !== res.data.email) {
          history.push({
            pathname: `/home`,
            state: {
              indexPageState: history?.location?.state?.indexPageState
                ? history.location.state.indexPageState
                : { alias: [], searchCallerId: "", pageNumber: 1 },
            },
          });
        } else {
          setIsLocked(true);
        }
      })
      .catch((err) => {
        console.log(err, "isLocked");
        history.push({ pathname: `/`, state: {} });
      });
  }, [cookies, history, props]);

  // Get the PDF using pdfCacheManager once the fax is unlocked.
  useEffect(() => {
    if (isLocked === true && props) {
      // For the parent PDF case:
      if (props?.location?.state?.pdfVal) {
        const faxId = props.location.state.pdfVal.Id;
        if (faxId) {
          pdfCacheManager
            .fetchPdfWithCache(
              `${process.env.REACT_APP_BaseUrl}viewpdf/${faxId}`,
              faxId,
            )
            .then((blob) => {
              setUploadeFiles(blob);
            })
            .catch((err) => {
              console.log(err, "viewpdf");
            });
        }
        // Process any child PDF pages from the parent PDF data.
        const childPdfAry = props.location.state.pdfVal.ChildPdf;
        const childPdfAryLength = childPdfAry?.length;
        if (childPdfAryLength > 0) {
          const childPagesAry = childPdfAry
            .map((child) => child.pages)
            .reduce((r, a) => r.concat(a), []);
          setPagesArray(childPagesAry);
        }
      }
      // For the child PDF case:
      else if (props?.location?.state?.parent) {
        setCurrentPage("child");
        const parentId = props.location.state.parent.Id;
        const childId = props.location.state.child.id;
        pdfCacheManager
          .fetchPdfWithCache(
            `${process.env.REACT_APP_BaseUrl}viewpdf/${parentId}/${childId}`,
            parentId,
            true,
            childId,
          )
          .then((blob) => {
            setUploadeFiles(blob);
          })
          .catch((err) => {
            console.log(err, "viewpdf");
          });
        const childPdfAryTemp = props.location.state.child.pages;
        setpageOriginalNum([...childPdfAryTemp]);
      }
    }
  }, [isLocked, props]);

  // Set the PDF to be used by the thumbnail component.
  useEffect(() => {
    if (uploadFiles) {
      setUploadedPdf(uploadFiles);
    }
  }, [uploadFiles]);

  // Cached thumbnail view using useMemo.
  const cachedValue = useMemo(() => {
    return (
      <PdfThumnailView
        pdf={uploadedPdf}
        pagesArray={[...pagesArray]}
        pageOriginalNum={[...pageOriginalNum]}
      />
    );
  }, [uploadedPdf, pagesArray, pageOriginalNum]);

  return (
    <>
      {cookies.firstName ? (
        <div>
          <Navbar />
          {uploadedPdf ? (
            <Container className="docview">
              {currentPage === "parent" ? (
                <DocView
                  currentPage={currentPage}
                  pdfTotalPages={parseInt(props.location.state.pdfVal.Pages)}
                  chaildPdfPage={[...pagesArray]}
                  uploadedPdf={uploadedPdf}
                  pdfObject={props.location.state}
                />
              ) : (
                <DocView
                  currentPage={currentPage}
                  pdfTotalPages={0}
                  chaildPdfPage={[]}
                  uploadedPdf={uploadedPdf}
                  pdfObject={props.location.state}
                />
              )}
              <Row className="rowmargin">
                <Col
                  className="mt-4 mb-4 inputpdf"
                  sm={12}
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 5px",
                  }}
                >
                  <PdfThumnailView
                    pdf={uploadedPdf}
                    pagesArray={[...pagesArray]}
                    pageOriginalNum={[...pageOriginalNum]}
                  />
                </Col>
              </Row>
            </Container>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ViewPage;
